import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATE, DATETIME, STRING, UUID } from '@/plugins/sdk/fields'

export default class ServiceDisruption extends Resource {
  static name = 'servicedisruption'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      start_date: new DATE(),
      end_date: new DATE(),
      state: new STRING(),
      postcode_from: new STRING(),
      postcode_to: new STRING(),
      service_type_id: new STRING(),
      carrier_id: new STRING(),
      carrier_service_id: new STRING(),
      zone_from: new STRING(),
      zone_to: new STRING(),
      account_id: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted: new BOOLEAN(),
      deleted_at: new DATETIME()
    }
  }
}
